module.exports = __webpack_public_path__ + "static/media/nag2.e043f2f1.png";